<div class="content">
  <div class="title">
    <h2>Profile</h2>
    <a matIconButton (click)="editProfile()"
      ><mat-icon fontSet="material-symbols-outlined">edit</mat-icon></a
    >
  </div>
  <app-account-profile-card></app-account-profile-card>
  <div class="title">
    <h2>Addresses</h2>
    <a matIconButton (click)="editAddress()"
      ><mat-icon fontSet="material-symbols-outlined">add</mat-icon></a
    >
  </div>
  <div class="addresses">
    @if (loading) {
    <div class="loading">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    } @else if (addresses.length===0) {
    <nz-empty nzNotFoundContent="No Address"></nz-empty>
    }@else {
    <div class="items">
      @for (address of addresses; track $index) {
      <app-user-shipping-address-list-item
        [address]="address"
        (click)="editAddress(address)"
      ></app-user-shipping-address-list-item>
      }
    </div>
    }
  </div>
</div>
